import { BarcodeType } from "../../../../../../models";
import { DataAPI_Base, GetAPI_Base } from "../base";

class GetAPI_BarcodeTypes extends GetAPI_Base<BarcodeType> {
	constructor() {
		super("barcode-types", BarcodeType);
	}
}

export class BarcodeTypesAPI extends DataAPI_Base<BarcodeType> {
	get: GetAPI_BarcodeTypes;
	constructor() {
		super("barcode-types", BarcodeType);
		this.get = new GetAPI_BarcodeTypes();
	}
}
